<script >
  export default {
    name:'ptApsRule',
    methods:{
      getRule(){
          window.open("https://bms2-project.oss-cn-shenzhen.aliyuncs.com/public/APS%E8%AF%84%E5%88%86%E7%BB%86%E5%88%99.pdf", "_black")
      }
    }
  }
</script>

<template>
    <div>
      <div style='background: #FFE4B9;
                      margin-left: 20px;
                      padding: 3px 8px;
                      margin-bottom: 5px;
                      cursor: pointer;
                      font-size: 12px;
                      border-radius: 5px;' @click="getRule">
        <a-icon style="margin-right: 5px" type="question-circle"/> <span>{{ $t('apsRule.scoringRules') }}</span>
      </div>
    </div>
</template>

<style scoped lang="less">

</style>